var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4123_39025)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7275 4.00426C13.7326 4.00426 15.7378 4.00426 17.743 4.00426C18.9232 4.00426 19.1046 4.19731 19.1084 5.42307C19.1084 6.41911 19.1084 7.41709 19.1084 8.41313C19.1084 9.01732 19.0015 9.55779 18.2681 9.5462C17.5959 9.53462 17.4718 9.0289 17.4756 8.45946C17.4756 7.75296 17.4489 7.04453 17.4756 6.3361C17.4985 5.82457 17.3018 5.67784 16.811 5.67977C13.4704 5.69778 10.1297 5.69778 6.789 5.67977C6.27148 5.67977 6.12634 5.8728 6.14162 6.35538C6.16644 7.09469 6.14162 7.83593 6.14162 8.57525C6.14162 9.12153 5.95065 9.54041 5.33382 9.54041C4.71699 9.54041 4.51838 9.13118 4.51838 8.57525C4.51838 7.44794 4.54512 6.32256 4.50693 5.19719C4.47446 4.31503 4.8774 3.98108 5.70621 3.98687C7.71902 4.0139 9.72419 4.00426 11.7275 4.00426Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6165 10.4299L12.6165 16.6629C12.6165 17.0798 12.6165 17.4968 12.6165 17.9137C12.6031 18.5392 12.7635 19.3518 11.8297 19.375C10.8959 19.3982 11.0009 18.6029 10.999 17.9601C10.999 15.7769 10.999 13.5937 10.999 11.4105L10.999 10.3334C10.4509 10.5592 10.2026 10.9723 9.87227 11.2734C9.4636 11.646 9.03201 11.7753 8.6176 11.341C8.2032 10.9067 8.33306 10.4646 8.72264 10.0727C9.53044 9.25429 10.3363 8.43391 11.1499 7.62125C11.5872 7.185 12.0398 7.17341 12.4866 7.62125C13.2976 8.43584 14.106 9.253 14.9119 10.0727C15.2939 10.4588 15.4352 10.9067 15.017 11.341C14.5987 11.7753 14.1442 11.6769 13.7699 11.2657C13.4701 10.9376 13.2219 10.5611 12.9526 10.2079L12.6165 10.4299Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4123_39025"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.5977,
    height: 15.375,
    fill: "white",
    transform: "translate(19.1094 19.375) rotate(-180)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrending);
export default __webpack_public_path__ + "static/media/trending.5c62e9de30fca71df94d479f3b7f6fd2.svg";
export { ForwardRef as ReactComponent };